import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import { ToastContainer, Zoom } from 'react-toastify';
import 'styles/index.less';
import 'react-quill/dist/quill.snow.css';
import 'react-date-range/dist/styles.css';
import 'slick-carousel/slick/slick.css';
import { configure } from 'mobx';
import { logger } from '@cutwise/utils';
import { alertStore } from '@/alert/stores/AlertStore';
import { getEnvironment } from '@/common/helpers/getEnvironment';
import Notifier from '@/common/services/Notifier';
import { configurationStore } from '@/common/stores/ConfigurationStore';
import { netBoxStore } from '@/netbox/stores/NetBoxStore';
import { StoreProvider } from '@/store';
import Root from './Root';
const BrowserSupport = lazy(() => import('@/common/components/BrowserSupport/BrowserSupport'));
configure({ isolateGlobalState: true });
logger.configure({ prefix: 'CUTWISE' });
netBoxStore.connectToNetBox();
// load alerts sooner, so when app mount we will show alerts in header,
// otherwise, dynamic alerts will make header jumping
alertStore.getAlerts().catch((e) => {
    logger.error(e);
});
// load constants as soon as possible, before App starts render
configurationStore.fetchServerConstants();
ReactDOM.render(_jsx(Suspense, { fallback: null, children: _jsx(BrowserSupport, {}) }), document.getElementById('browser-support-container'));
ReactDOM.render(_jsx(ToastContainer, { hideProgressBar: true, limit: 4, transition: Zoom }), document.getElementById('notifications-container'));
ReactDOM.render(_jsx(StoreProvider, { children: _jsx(Suspense, { fallback: null, children: _jsx(Root, {}) }) }), document.getElementById('app'));
window.addEventListener('offline', () => {
    Notifier.warn('Internet connection is lost');
});
/*
 * Handle "UnhandledRejection" global event
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/unhandledrejection_event#basic_error_logging
 * */
window.addEventListener('unhandledrejection', (e) => {
    logger.error('Unhandled rejection (promise: ', e.promise, ', reason: ', e.reason, ').');
    e.preventDefault();
    e.stopPropagation();
});
window.onunhandledrejection = (e) => {
    logger.error('Unhandled rejection (promise: ', e.promise, ', reason: ', e.reason, ').');
    e.preventDefault();
    e.stopPropagation();
};
if ('serviceWorker' in navigator) {
    navigator.serviceWorker
        .register('/sw.js')
        .then((reg) => logger.info(`SW registration succeeded. Scope is ${reg.scope}`))
        .catch((err) => logger.error(`SW registration failed with error ${err}`));
}
/*
 * Fix this issue (check whole thread)
 * https://github.com/webpack/webpack-dev-server/issues/2792#issuecomment-724169118
 * */
if (getEnvironment() !== 'production') {
    module.hot?.accept();
}
